import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IClientList, SelectClientforsendHotList } from "./SelectClientforsendHotList";
import { Fetch } from "../../shared/Fetch";
import { IBenchConsultant } from "../../models/BenchConsultant";

export interface IMassEmail {
    to: string,
    else_To: string,
    subject: string,
}

interface IProps {
    data: string,
    open: boolean,
    hideDialog: () => void,
    onHide: () => void,
    toast: any,
    setSelectedBenchs: (is: IBenchConsultant[]) => void,
}

interface IMail {
    clients: Array<{ contact_Person_Id: number, contact_Person_EmailID: string }>,
    else_To: Array<string>,
    subject: string,
    emailBody: string
}

export const EmptyMassEmail: IMassEmail = {
    to: "",
    else_To: "",
    subject: "",
}

const schema = yup.object({
    to: yup.string().required("Add Clients To Send"),
    else_To: yup.string().nullable(),
    subject: yup.string().required("Subject is required"),
});


export const MassMail = (props: IProps) => {

    const [body, setBody] = useState("");
    const [saveDis, setSaveDis] = useState(false);
    const [selectClientforsendHotListVW, setSelectClientforsendHotListVW] = useState(false);
    const [selectedClients, setSelectedClients] = useState<Array<IClientList>>([]);
    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IMassEmail>({
        resolver: yupResolver(schema),
        defaultValues: EmptyMassEmail,
        shouldFocusError: false
    });



    const sendMail = async (fbody: IMail) => {
        fbody.emailBody = body;

        const _clients: Array<{ contact_Person_Id: number, contact_Person_EmailID: string }> = [];
        selectedClients.forEach(d => {
            const client: { contact_Person_Id: number, contact_Person_EmailID: string } = {
                contact_Person_Id: d.contact_Person_Id,
                contact_Person_EmailID: d.contact_Person_EmailID
            }
            _clients.push(client);
        });
        fbody.clients = _clients;
        const response = await Fetch("Email_Template/sendEmailToClients", "POST", fbody, null, props.toast);
        if (response) {
            props.onHide();
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Mail Sended Successfully.", life: 3000 });
            reset(EmptyMassEmail);
            setSaveDis(false);
            props.setSelectedBenchs([]);
        }
    }

    const onSubmit = (data: IMassEmail) => {
        if (body === "" || body === null) {
            props.toast.current?.show({ severity: 'error', detail: "Comment field is required", life: 3000 });
            setSaveDis(false);
        } else {
            setSaveDis(true);
            let emailBody: IMail = {
                clients: selectedClients.map(el =>{ return { contact_Person_Id: el.contact_Person_Id, contact_Person_EmailID: el.contact_Person_EmailID} }),
                subject: data.subject,
                emailBody: props.data,
                else_To: [],
            }

            let emailStr = [];
            if(data.else_To != ""){
                emailStr = data.else_To.split(",");
                emailBody.else_To = emailStr.map(el => el.trim());
            }

            sendMail(emailBody);
        }
    }

    const onHide = () => {
        props.hideDialog();
        setSelectedClients([]);
    }

    useEffect(() => {
        if (selectedClients.length > 0) {
            setValue("to", selectedClients.map(el => el.contact_Person_EmailID).join(", "));
        }
    }, [selectedClients]);

    useEffect(() => {
        reset(EmptyMassEmail);
        setBody(props.data);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Send Alert Email To Vendor Pending Documents" modal className="p-fluid" onHide={onHide} maximizable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput  column={2} label="To:" control={control} name="to" placeholder="Enter To" error={errors.to?.message} disabled={true} />
                <JVInput column={2} label="Else To:" control={control} name="else_To" placeholder="Enter Else To" error={errors.else_To?.message} />

                <div className="flex gap-4 mt-1 col-12 md:col-12">
                    <Button className="field col md:col h-2rem" label="Add Client" onClick={() => setSelectClientforsendHotListVW(true)} />
                    <Button className="field col md:col h-2rem" label="Clear To" onClick={() => { setValue("to", ""); setSelectedClients([]); }} />
                    <SelectClientforsendHotList open={selectClientforsendHotListVW} hideDialog={() => setSelectClientforsendHotListVW(false)} toast={props.toast} setSelectedClients={setSelectedClients} selectedClientList={selectedClients} />
                </div>

                <JVInput required column={1} label="Subject:" control={control} name="subject" placeholder="Enter Subject" error={errors.subject?.message} />

                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label>Body</label>
                    <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 mt-5">
                    <Button className="field col md:col" label="SEND" type="submit" loading={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}